import { SchemeBase } from '../../../../checkout/cart/scheme.class';
import { PlanBase } from '../plan';

export class PremiumBase extends PlanBase {
    /**
     * Add plan gencode in context for EDP contextualisation
     * @param scheme
     * @returns
     */
    public updateSchemeOnAdd(scheme: SchemeBase): SchemeBase {
        scheme.productContext.plan = this.gencode;
        scheme.updateContext(scheme.productContext);
        return scheme;
    }

    /**
     * Remove plan gencode in context if you remove plan
     * @param scheme
     * @returns
     */
    public updateSchemeOnRemove(scheme: SchemeBase): SchemeBase {
        super.updateSchemeOnRemove(scheme);
        delete scheme.productContext.plan;
        scheme.updateContext(scheme.productContext);
        return scheme;
    }
}
